<template>
  <Dimmable :dimmed="searchIsFocused">
    <ul v-bem:menu.firstLevel>
      <li
        v-for="(item, index) in $store.state.pageHeader.menuData"
        :key="index"
        v-bem:item.firstLevel="{ isOpen: isActive(index) }"
      >
        <a
          v-bem:link.firstLevel="{
            isOpen: isActive(index),
            hasChildren: item.children && item.children.length,
          }"
          :href="item.children ? '#' : item.url"
          @click="openSubmenu(isActive(index) ? null : index)"
        >
          {{ item.title }}
        </a>
        <slide-up-down v-bem:backdrop :active="isActive(index)" :duration="250">
          <ul v-bem:menu.secondLevel>
            <li
              v-for="(child, childIndex) in item.children"
              :key="childIndex"
              v-bem:item.secondLevel
            >
              <a v-bem:link.secondLevel :href="child.url">
                {{ child.title }}
              </a>
            </li>
          </ul>
        </slide-up-down>
      </li>
    </ul>
  </Dimmable>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Dimmable from '../Dimmable.vue';

export default {
  name: 'MainMenu',
  components: { Dimmable },
  computed: {
    ...mapState('pageHeader', ['activeSubmenu', 'searchIsFocused']),
    ...mapGetters('pageHeader', ['activeSubmenuChildren']),
  },
  methods: {
    ...mapActions('pageHeader', ['openSubmenu', 'closeSubmenu']),
    isActive(index) {
      return (
        this.activeSubmenuChildren.length > 0 && this.activeSubmenu === index
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use 'sass:map';

.main-menu {
  @at-root #{&}__menu {
    padding: 0;
    margin: 0;
    list-style-type: none;
    white-space: nowrap;

    @at-root #{&}--first-level {
      padding: 0 utils.f-rem-calc(16);
    }

    @at-root #{&}--second-level {
      padding: utils.f-rem-calc(12) 0;
    }
  }

  @at-root #{&}__item {
    @at-root #{&}--first-level {
      border-bottom: 1px solid map.get(utils.$v-colors, acc-gray-040);
    }

    @at-root #{&}--is-open {
      border-color: transparent;
    }
  }

  @at-root #{&}__link {
    color: #{map.get(utils.$v-colors, acc-gray-080)};
    text-decoration: none;
    font-size: utils.f-rem-calc(16);
    line-height: utils.f-rem-calc(24);
    transition: all 320ms;

    &:hover {
      color: map.get(utils.$v-colors, acc-orange);
    }

    @at-root #{&}--is-active {
      color: map.get(utils.$v-colors, acc-orange);
    }

    @at-root #{&}--first-level {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: utils.f-rem-calc(15) 0;
    }

    // First level arrows
    @at-root #{&}--has-children::after {
      @include utils.m-icon(dropdown-arrow, orange);
      content: '';
      display: block;
      width: 12px;
      height: 20px;
      margin-right: 12px;
      transform: rotate(0deg);
      transition: transform 320ms;
      transform-origin: center;
    }

    @at-root #{&}--is-open {
      color: map.get(utils.$v-colors, acc-orange);

      &::after {
        transform: rotate(90deg);
      }
    }

    @at-root #{&}--second-level {
      display: block;
      padding: utils.f-rem-calc(5) 0;
    }
  }

  @at-root #{&}__backdrop {
    margin: 0 utils.f-rem-calc(-16);
    padding: 0 utils.f-rem-calc(16);
    background-color: map.get(utils.$v-colors, acc-gray-020);
  }
}
</style>
